import { render, staticRenderFns } from "./section-card.vue?vue&type=template&id=c660fd36&"
import script from "./section-card.vue?vue&type=script&lang=js&"
export * from "./section-card.vue?vue&type=script&lang=js&"
import style0 from "./section-card.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports